import { openBlock as e, createElementBlock as s, normalizeClass as r, renderSlot as a } from "vue";
/* empty css                    */
import n from "./design-system.es128.js";
const p = {
  name: "DsToastGroup",
  props: {
    position: {
      type: String,
      default: "end",
      validator: (t) => ["start", "center", "end"].includes(t)
    }
  }
};
function d(t, i, o, c, u, l) {
  return e(), s("div", {
    class: r(["toast-group ds-toast-group", `ds-toast-group--position-${o.position}`])
  }, [
    a(t.$slots, "default", {}, void 0, !0)
  ], 2);
}
const $ = /* @__PURE__ */ n(p, [["render", d], ["__scopeId", "data-v-b9111cac"]]);
export {
  $ as default
};
//# sourceMappingURL=design-system.es4.js.map
